import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import AvatarPlaceholder from './AvatarPlaceholder';
import AvatarPlaceholderV2 from '../AvatarPlaceholder.group_profiles';
export default withFeatureBranch({
    group_profiles: AvatarPlaceholderV2
})(AvatarPlaceholder);

//# sourceMappingURL=index.js.map